import { HttpRequest } from "../utils";

const httpRequest = new HttpRequest();

type IPassword = {
  password: string;
  oldPassword?: string;
};

export const change = async (data: IPassword, extras?: { silent?: boolean }) => {
  const res = await httpRequest.post(`/2fa/auth/password/change`, data, extras);
  return res;
};
